import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { AppState } from "../../store/configureStore";
import { UserData } from "../../actions/authentificationActions";
import { getUsers } from "../../services/userService";
import { CreateUserForm } from "./CreateUserForm";
import { UsersTable } from "./UsersTable";
import { UserSettings } from "./UserSettings";
import { isLocalLoginEnabled } from "../../services/authenticationService";
import "./UsersDashboard.css";

export const UsersDashboard = () => {
    const user = useSelector((state: AppState) => state.user);
    const [users, setUsers] = useState<UserData[]>([]);
    const [localLoginEnabled, setLocalLoginEnabled] = useState<boolean>(false);

    const handleConcatUser = (newUser: UserData) => {
        if (user.role === "SuperAdmin" || newUser.role !== "Admin") setUsers(users.concat(newUser));
    };

    useEffect(() => {
        isLocalLoginEnabled().then(enabled => {
            setLocalLoginEnabled(enabled);
        });
    }, [users]);

    useEffect(() => {
        const fetchUsers = async () => {
            let users = await getUsers();
            /*
            if (user.role === "SuperAdmin") {
                // SuperAdmin can see all users except other SuperAdmins
                users = users.filter(x => x.role !== "SuperAdmin");
            } else if (user.role === "Admin") {
                // Admin can see all users except other Admins and SuperAdmins
                users = users.filter(x => x.role !== "Admin" && x.role !== "SuperAdmin");
            } else if (user.role === "TSOAdmin") {
                // TSOAdmin can see all users except other TSOAdmins, Admins and SuperAdmins
                // TSO Admins can see TSO Admin and TSO users for his TSO
                users = users.filter(
                    x =>
                        (x.role === "TSOAdmin" ||
                            x.role === "TSO") &&
                        x.tso === user.tso || x.tsoNameDescription === user.tso
                );
                /*
                users = users.filter(
                    x =>
                        x.role !== "Admin" &&
                        x.role !== "SuperAdmin" &&
                        x.role !== "TSOAdmin" &&
                        x.tso === user.tso
                );
                */
            //}
            setUsers(users);
        };
        fetchUsers();
    }, [user.role, user.tso]);

    return (
        <div id="userDashboard-container-div" className="user-dashboard-container">
            <div id="userDashboard-title-div" className="user-dashboard-title tsc-blue">
                <h1 id="page-title-userDashboard">Users Dashboard</h1>
            </div>
            <div id="userDashboard-content-div" className="user-dashboard-content">
                <div id="userDashboard-half-div-a" className="user-dashboard-half">
                    {user.role !== "TSOAdmin" && (
                        <div>
                            <h2 id="h2-userDashboard-a" className="tsc-blue">
                                Settings
                            </h2>
                            <UserSettings />
                        </div>
                    )}
                    <br id="br-userDashboard-a" />
                    <h2 id="h2-userDashboard-reduce-margin" className="tsc-blue reduced-margin">
                        Users list
                    </h2>
                    <UsersTable
                        users={users}
                        setUsers={setUsers}
                        localLoginEnabled={localLoginEnabled}
                    />
                </div>
                <span id="span-userDashboard-a" className="divider">
                    {" "}
                </span>
                {user.role !== "TSOAdmin" && (
                    <div id="userDashboard-half-div-b" className="user-dashboard-half">
                        <h2 id="h2-userDashboard-b" className="tsc-blue">
                            Add user
                        </h2>
                        <CreateUserForm
                            handleConcatUser={handleConcatUser}
                            localLoginEnabled={localLoginEnabled}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};
